#This whole thing is a big patch that sould eventually die
class Customer.Methods.WebchatAttachmentsManager

  constructor: (@attachments=[]) ->
    @possibleTypes = ['images', 'videos', 'audios', 'files']

  hasAttachments: () =>
    @attachments.length > 0

  getAttachments: (att_type) =>
    type_attachments = []
    return type_attachments unless att_type in @possibleTypes
    _.each(@attachments, (attachment) =>
      if this["is_type_#{att_type}"](attachment)
        type_attachments.push(this[att_type](attachment))
    )
    type_attachments

  is_type_images: (att)->
    att.content_type.indexOf( "image" ) > -1

  is_type_videos: (att)->
    (att.content_type.indexOf( "video" ) > -1)  || (att.content_type.indexOf( "mp4" ) > -1)

  is_type_audios: (att)->
    att.content_type.indexOf( "audio" ) > -1

  is_type_files: (att)->
    !(@is_type_images(att) || @is_type_videos(att) || @is_type_audios(att))

  genericMapping: (att) ->
    {
      url: att.url
      preview_url: att.url
      mime_type: att.content_type
      name: att.name.replace(/ /g, "-")
    }

  images: (attachment) ->
    @genericMapping(attachment)

  files: (attachment) ->
    @genericMapping(attachment)

  audios: (attachment) ->
    @genericMapping(attachment)

  videos: (attachment) ->
    _.extend({height: "0px", width: "0px"}, @genericMapping(attachment))
